import type { CampoConfiguravel } from "@bookdental/schemas";
import { useConfiguracaoDePacientes } from "@/lib/use-configuracao-de-pacientes";

/** Configurações › Pacientes na aba Dados: oculto some, obrigatório não deixa apagar. */
export function useCamposDaFicha() {
  const campos = useConfiguracaoDePacientes().cadastro.campos;
  return {
    ver: (c: CampoConfiguravel) => campos[c] !== "oculto",
    obrigatorio: (c: CampoConfiguravel) => campos[c] === "obrigatorio",
  };
}
